import React from "react";

import PromopostEditor from "../_PromopostEditor/PromopostEditor";

const PromosCreate = ({
  menus,
  handleCreatePromopost,
  mediaURLs,
  setMediaURLs
}) => {
  const initialPromopost = {
    promopostBackgroundPictureURL: "",
    promopostBody: "",
    promopostDate: new Date(Date.now()).toISOString(),
    promopostHeading: "",
    promopostName: ""
  };

  return (
    <div className="subSection">
      <h3 className="subSection__heading">CREATE NEW POST</h3>
      <PromopostEditor
        promopost={initialPromopost}
        staticMenus={menus}
        handleSavePromopost={handleCreatePromopost}
        mediaURLs={mediaURLs}
        setMediaURLs={setMediaURLs}
      />
    </div>
  );
};

export default PromosCreate;
